import { useState, Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import { connect, CustomContainer } from "../../atoms/DependencyHelper";
import types from "../../../config/types";
import * as FIXED from "../../../config/constants";
import {
  getDealFilterByCategory,
  getDealFilterByData,
  getDealFilterByAirTime,
  getDealFilterByVoiceMinutes,
  getDealFilterByProductNames,
} from "../../../services/filterDealService";
import { displayHideFooter } from "../../../Redux/actions/footerAction";
import {
  componentCheckSize,
  isValueSelected,
} from "../../../utils/helperServices";
import Brands from "../../molecules/brands/Brands";
import Products from "../../molecules/Products/Products";
import DealSliderFilter from "../../molecules/dealSliderFilter/DealSliderFilter";
import FilterNav from "../../molecules/filterNav/FilterNav";
import SearchItemContainer from "../searchItemContainer/SearchItemContainer";
import PromoMobile from "../searchItemContainer/PromoMobile";
import ContractTypeMobile from "../searchItemContainer/contractTypeMobile";
import PlanTypeMobile from "../searchItemContainer/planTypeMobile";
import PlanNameMobile from "../searchItemContainer/planNameMobile";
import AccessoriesMobile from "../searchItemContainer/accessoriesMobile";
import ContractDurationMobile from "../searchItemContainer/contractDurationMobile";
import Categories from "../../molecules/categoryItems/Categories";
import PriceFilterMobile from "../../molecules/priceFilterMobile/PriceFilterMobile";
import DataVmAirtimeMobileItem from "../searchItemContainer/DataVmAirtimeMobileItem";
import VoiceMobileItem from "../searchItemContainer/VoiceMobileItem";
import AirtimeMobileItem from "../searchItemContainer/AirtimeMobileItem";
import Promotions from "../../molecules/promotions/Promotions";
import PlanType from "../../molecules/planType/PlanType";
import PlanName from "../../molecules/planName/PlanName";
import Accessories from "../../molecules/accessories/Accessories";
import ContractDuration from "../../molecules/contractDuration/ContractDuration";
import ContractType from "../../molecules/contractType/ContractType";
import SubCategoryMobileItem from "../subCategoryMobileItem/SubCategoryMobileItem";
import styles from "./DealGridSearchContainer.module.scss";
import * as Analytics from "../../../services/analyticsUtag";
import { breadcrumbGenerator } from "../../../services/breadcrumbService";
import ProductFilter from "../ProductFilter/ProductFilter";
import ProductFilterMobile from "../ProductFilter/ProductFilterMobile";
import labels from "../../../config/labels";
import { toggleFilters } from "../../../Redux/actions/navAction";

const DealGridSearchContainer = (props) => {
  const isMobile = componentCheckSize() < FIXED.MOBILE_WIDTH;
  const [showBrand, setShowBrand] = useState(false);
  const [showCate, setShowCate] = useState(false);
  const [showPrice, setShowPrice] = useState(false);
  const [showPromo, setShowPromo] = useState(false);
  const [showContractType, setShowContractType] = useState(false);
  const [showPlanType, setshowPlanType] = useState(false);
  const [showPlanName, setshowPlanName] = useState(false);
  const [showAccessories, setshowAccessoories] = useState(false);
  const [showcontractDuration, setshowContractDuration] = useState(false);
  const [showSubCategory, setShowSubCategory] = useState(false);
  const [showData, setShowData] = useState(false);
  const [showDataVmAirtime, setShowDataVmAirtime] = useState(false);
  const [showVoiceMinutes, setShowVoiceMinutes] = useState(false);
  const [showAirtime, setShowAirtime] = useState(false);
  const [showFilterByProduct, setShowFilterByProduct] = useState(false);
  let [selectedType, setSelectedType] = useState("");
  const [isMounted, setIsMounted] = useState(false);
  const [tempSelectedFilter, setTempSelectedFilter] = useState({
    originalSelectection: {},
    intermrdiateSelection: {},
  });

  useEffect(() => {
    props.displayHideFooter(props.hide);
  });

  useEffect(() => {
    setShowFilterByProduct(
      props.showProductFilter ? props.showProductFilter : false
    );
  }, [props.showProductFilter]);

  useEffect(() => {
    if (
      props.hide &&
      (!showBrand ||
        !showPromo ||
        !showContractType ||
        !showPlanType ||
        !showcontractDuration ||
        !showPlanName ||
        !showDataVmAirtime)
    ) {
      if (!isMounted) {
        setIsMounted(true);
        setTempSelectedFilter({
          originalSelectection: { ...props.selectedFilter },
          intermrdiateSelection: { ...props.selectedFilter },
        });
      } else {
        let originalValue =
          props.selectedFilter !== tempSelectedFilter.originalSelectection
            ? props.selectedFilter
            : tempSelectedFilter.originalSelectection;
        setTempSelectedFilter({
          originalSelectection: { ...originalValue },
          intermrdiateSelection: { ...props.selectedFilter },
        });
      }
    }
  }, [
    props.hide,
    showBrand,
    showPromo,
    showContractType,
    showPlanType,
    showcontractDuration,
    showPlanName,
    showDataVmAirtime,
  ]);

  const handleCategorySelect = (category) => {
    props.onCategoryChange(category);
  };

  const selectPrice = (value) => {
    props.onPriceChange(value);
  };

  const selectPriceMobile = (value, type) => {
    setSelectedType(type);
    props.onPriceChange(value, false);
  };

  const selectData = (value) => {
    props.onDataChange(value);
  };

  const selectDataMobile = (value) => {
    props.onDataChange(value, false);
  };

  const selectAirTime = (value) => {
    props.onAirTimeChange(value);
  };

  const selectAirTimeMobile = (value) => {
    props.onAirTimeChange(value, false);
  };

  const selectVoiceMinutes = (value) => {
    props.onVoiceMinutesChange(value);
  };

  const selectVoiceMinutesMobile = (value) => {
    props.onVoiceMinutesChange(value, false);
  };

  const selectContractType = (flag, value) => {
    hideContractTypes();
    props.onContractTypeChange(flag, value);
  };

  const selectSubCategoryChange = (flag, value) => {
    props.onSubCategoryChange(flag, value);
  };

  const allProductsClickHandler = () => {
    props.onFilterReset();
  };

  const toggleBrand = () => setShowBrand(!showBrand);
  const hideBrands = () => setShowBrand(false);
  const toggleCategory = () => setShowCate(!showCate);
  const hideCategories = () => setShowCate(false);
  const togglePrice = () => setShowPrice(!showPrice);
  const hidePrice = () => setShowPrice(false);
  const toggleData = () => setShowData(!showData);
  const toggleDataVmAirtime = () => setShowDataVmAirtime(!showDataVmAirtime);
  const hideDataVmAirtime = () => setShowDataVmAirtime(false);
  const toggleVoiceMinutes = () => setShowVoiceMinutes(!showVoiceMinutes);
  const hideVoiceMinutes = () => setShowVoiceMinutes(false);
  const toggleAirtime = () => setShowAirtime(!showAirtime);
  const hideAirtime = () => setShowAirtime(false);
  const togglePromotions = () => setShowPromo(!showPromo);
  const hidePromo = () => setShowPromo(false);
  const toggleContractTypes = () => setShowContractType(!showContractType);
  const hideContractTypes = () => setShowContractType(false);
  const togglePlanTypes = () => setshowPlanType(!showPlanType);
  const hidePlanType = () => setshowPlanType(false);
  const togglePlanNames = () => setshowPlanName(!showPlanName);
  const hidePlanName = () => setshowPlanName(false);
  const toggleAccessories = () => setshowAccessoories(!showAccessories);
  const hideAccessories = () => setshowAccessoories(false);
  const toggleContractDuration = () =>
    setshowContractDuration(!showcontractDuration);
  const hideContractDuration = () => setshowContractDuration(false);
  const toggleSubCategory = () => setShowSubCategory(!showSubCategory);
  const hideSubCategory = () => setShowSubCategory(false);

  const breadcrumbs = breadcrumbGenerator().deals.reverse();
  const section_lvls = {};
  let index = 0;
  for (let item of breadcrumbs) {
    index = index + 1;
    if (index > 4) break;
    section_lvls[`page_site_section_lvl_${index}`] = item.label;
  }

  const analyticsData = (filter = "") => {
    Analytics.link({
      page_name: "shopping: deals grid: browse all deals",
      page_channel: "shopping",
      page_tool_event: "use",
      page_tool_name:
        filter === ""
          ? "shopping: deals grid: browse all deals: reset all filters"
          : `shopping: deals grid: browse all deals: reset ${filter}`,
      page_master_tab: "personal",
      ...section_lvls,
    });
  };

  const resetClickHandler = () => {
    let newIntermediateSel = tempSelectedFilter.intermrdiateSelection;
    if (showBrand) {
      newIntermediateSel.brands = [];
      setTempSelectedFilter({
        ...tempSelectedFilter,
        intermrdiateSelection: newIntermediateSel,
      });
      analyticsData("brands");
    } else if (showPromo) {
      newIntermediateSel.promotions = [];
      setTempSelectedFilter({
        ...tempSelectedFilter,
        intermrdiateSelection: newIntermediateSel,
      });
      analyticsData("promotions");
    } else if (showPrice) {
      props.onFilterReset("price");
      analyticsData("price");
    } else if (showPlanType) {
      analyticsData("plan type");
      newIntermediateSel.plantypes = [];
      setTempSelectedFilter({
        ...tempSelectedFilter,
        intermrdiateSelection: newIntermediateSel,
      });
    } else if (showContractType) {
      newIntermediateSel.contracttype = [];
      setTempSelectedFilter({
        ...tempSelectedFilter,
        intermrdiateSelection: newIntermediateSel,
      });
      analyticsData("contract type");
      hideContractTypes();
    } else if (showData) {
      getDealFilterByData({}).then(props?.onFilterChange);
      analyticsData("data");
    } else if (showDataVmAirtime) {
      let newValue = { ...tempSelectedFilter.intermrdiateSelection };
      delete newValue?.promo_data;
      delete newValue?.minutes;
      delete newValue?.airtime;
      setTempSelectedFilter({
        originalSelectection: tempSelectedFilter.originalSelectection,
        intermrdiateSelection: newValue,
      });
      props.setSelectedFilter(newValue);
      analyticsData("data");
    } else if (showVoiceMinutes) {
      analyticsData("voice minutes");
      getDealFilterByVoiceMinutes({}).then(props?.onFilterChange);
    } else if (showAirtime) {
      getDealFilterByAirTime({}).then(props?.onFilterChange);
      analyticsData("airtime");
    } else if (showcontractDuration) {
      newIntermediateSel.contractduration = [];
      setTempSelectedFilter({
        ...tempSelectedFilter,
        intermrdiateSelection: newIntermediateSel,
      });
      analyticsData("contract duration");
    } else if (showPlanName) {
      newIntermediateSel.plannames = [];
      setTempSelectedFilter({
        ...tempSelectedFilter,
        intermrdiateSelection: newIntermediateSel,
      });
      analyticsData("plan name");
    } else if (showCate) {
      getDealFilterByCategory("").then(props?.onFilterChange);
      analyticsData("categories");
    } else if (showFilterByProduct) {
      getDealFilterByProductNames([]).then(props?.onFilterChange);
    } else {
      props.onFilterReset();
      setTempSelectedFilter({
        originalSelectection: {},
        intermrdiateSelection: {},
      });
      analyticsData();
    }
  };

  const isBrandChecked = (brand) =>
    isValueSelected(props?.selectedFilter, brand, "brands");
  const isPromotionChecked = (promo) =>
    isValueSelected(props?.selectedFilter, promo, "promotions");
  const isContractTypeChecked = (contract) =>
    isValueSelected(props?.selectedFilter, contract, "contracttype");
  const isPlanTypeChecked = (planType) =>
    isValueSelected(props?.selectedFilter, planType, "plantypes");
  const isPlanNameChecked = (planName) =>
    isValueSelected(props?.selectedFilter, planName, "plannames");
  const isAccessoriesChecked = (accessory) =>
    isValueSelected(props?.selectedFilter, accessory, "accessories");
  const isContractDurationChecked = (duration) =>
    isValueSelected(props?.selectedFilter, duration, "contractduration");

  if (showBrand && props.hide) {
    return (
      <SearchItemContainer
        brands={props.brands}
        hideBrands={hideBrands}
        brandSelectHandler={(flag, brandObjObj) =>
          props?.onBrandChange(flag, brandObjObj, false)
        }
        isBrandChecked={isBrandChecked}
        resetClickHandler={resetClickHandler}
        selectedFilter={props.selectedFilter}
        tempSelectedFilter={tempSelectedFilter.intermrdiateSelection}
        setSelectedFilter={props?.setSelectedFilter}
      />
    );
  }

  if (showCate && props.hide) {
    return (
      <Categories
        categoriesList={
          props.categoriesList && props.categoriesList.categories
            ? props.categoriesList.categories
            : []
        }
        selectHandler={props.getSelectedCategory}
        selected={props?.selectedCategory?.id}
        hideCategories={hideCategories}
        resetClickHandler={resetClickHandler}
        isDealGridPage={props?.isDealGridPage}
        tempSelectedFilter={tempSelectedFilter.intermrdiateSelection}
      />
    );
  }

  if (showSubCategory && props.hide) {
    return (
      <SubCategoryMobileItem
        selectedSubCategory={
          props && props.selectedFilter
            ? props.selectedFilter.selectedSubCategory
            : ""
        }
        subCategories={props?.selectedCategory?.subCategories}
        hideSubCategory={hideSubCategory}
        subCategorySelectHandler={selectSubCategoryChange}
      />
    );
  }

  const priceMinValue = props?.priceValue?.minValue
    ? Number(props.priceValue.minValue)
    : 0;
  const priceMaxValue = props?.priceValue?.maxValue
    ? Number(props.priceValue.maxValue)
    : props.maxPrice;

  if (showPrice && props.hide) {
    return (
      <PriceFilterMobile
        min={priceMinValue}
        max={priceMaxValue}
        minValue={0}
        maxValue={props?.maxPrice}
        valueRange={props.priceRange}
        missingValueRange={props?.missingPriceRange}
        onPriceChange={selectPriceMobile}
        hidePrice={hidePrice}
        resetClickHandler={resetClickHandler}
        priceType={types.TYPE_MONTHLY}
        hidePriceTypes={true}
        step={30}
        selectedFilter={
          props.priceValue && Object.keys(props.priceValue).length !== 0
        }
        priceValue={props?.priceValue}
        resetPriceType={() => ""}
        resetPriceValue={props?.setPriceValue}
      />
    );
  }

  if (showDataVmAirtime && props.hide) {
    return (
      <>
        <DataVmAirtimeMobileItem
          hideDataVmAirtime={hideDataVmAirtime}
          selectDataMobile={selectDataMobile}
          min={
            props?.promoValue?.[0]?.label
              ? Number(props?.promoValue[0]?.label)
              : 0
          }
          max={
            props?.promoValue?.[1]?.label
              ? Number(props?.promoValue[1]?.label)
              : FIXED.MAX_DATA
          }
          minValue={FIXED.MIN_DATA}
          maxValue={FIXED.MAX_DATA}
          hideVoiceMinutes={hideVoiceMinutes}
          selectVMMobile={selectVoiceMinutesMobile}
          minVm={
            props?.vmValue?.[0]?.label ? Number(props?.vmValue[0]?.label) : 0
          }
          maxVm={
            props?.vmValue?.[1]?.label
              ? Number(props?.vmValue[1]?.label)
              : FIXED.MAX_MINUTES
          }
          minValueVm={FIXED.MIN_MINUTES}
          maxValueVm={FIXED.MAX_MINUTES}
          hideAirtimeMob={hideAirtime}
          selectAirtimeMob={selectAirTimeMobile}
          minAir={
            props && props?.airValue ? Number(props?.airValue[0]?.label) : 0
          }
          maxAir={
            props && props?.airValue
              ? Number(props?.airValue[1]?.label)
              : FIXED.MAX_AIRTIME
          }
          minValueAir={FIXED.MIN_AIRTIME}
          maxValueAir={FIXED.MAX_AIRTIME}
          selectedFilter={props.selectedFilter}
          setSelectedFilter={props?.setSelectedFilter}
          tempSelectedFilter={tempSelectedFilter.intermrdiateSelection}
          resetClickHandler={resetClickHandler}
          step={30}
        />
      </>
    );
  }

  if (showVoiceMinutes && props.hide) {
    return (
      <VoiceMobileItem
        hideVoiceMinutes={hideVoiceMinutes}
        selectVMMobile={selectVoiceMinutes}
        min={props?.vmValue?.[0]?.label ? Number(props?.vmValue[0]?.label) : 0}
        max={
          props?.vmValue?.[1]?.label
            ? Number(props?.vmValue[1]?.label)
            : FIXED.MAX_MINUTES
        }
        minValue={FIXED.MIN_MINUTES}
        maxValue={FIXED.MAX_MINUTES}
        selectedFilter={props.selectedFilter}
        resetClickHandler={resetClickHandler}
        step={30}
      />
    );
  }

  if (showAirtime && props.hide) {
    return (
      <AirtimeMobileItem
        hideAirtimeMob={hideAirtime}
        selectAirtimeMobile={selectAirTime}
        min={props && props?.airValue ? props?.airValue[0]?.label : 0}
        max={
          props && props?.airValue
            ? props?.airValue[1]?.label
            : FIXED.MAX_AIRTIME
        }
        minValue={FIXED.MIN_AIRTIME}
        maxValue={FIXED.MAX_AIRTIME}
        selectedFilter={props.selectedFilter}
        resetClickHandler={resetClickHandler}
        step={30}
      />
    );
  }

  if (showPromo && props.hide) {
    return (
      <PromoMobile
        hidePromo={hidePromo}
        promotions={props.promotions ? props.promotions : ""}
        promotionClickHandler={(flag, promotionObj) =>
          props?.onPromotionChange(flag, promotionObj, false)
        }
        isPromotionChecked={isPromotionChecked}
        resetClickHandler={resetClickHandler}
        selectedFilter={props.selectedFilter}
        setSelectedFilter={props?.setSelectedFilter}
        tempSelectedFilter={tempSelectedFilter.intermrdiateSelection}
      />
    );
  }

  if (showContractType && props.hide) {
    return (
      <ContractTypeMobile
        hideContractType={hideContractTypes}
        filteredContractType={props.selectedFilter.contracttype}
        contracttypes={props.contracttype ? props.contracttype : ""}
        contracttypeClickHandler={(flag, contractValue) =>
          props?.onContractTypeChange(flag, contractValue, false)
        }
        isContractTypeChecked={isContractTypeChecked}
        resetClickHandler={resetClickHandler}
        selectedFilter={props?.selectedFilter}
        setSelectedFilter={props?.setSelectedFilter}
        tempSelectedFilter={tempSelectedFilter.intermrdiateSelection}
      />
    );
  }

  if (showPlanType && props.hide) {
    return (
      <PlanTypeMobile
        hidePlanType={hidePlanType}
        plantype={props.plantype ? props.plantype : ""}
        plantypeClickHandler={(flag, planValue) =>
          props?.onPlanTypeChange(flag, planValue, false)
        }
        isPlanTypeChecked={isPlanTypeChecked}
        resetClickHandler={resetClickHandler}
        selectedFilter={props?.selectedFilter}
        setSelectedFilter={props?.setSelectedFilter}
        tempSelectedFilter={tempSelectedFilter.intermrdiateSelection}
      />
    );
  }

  if (showPlanName && props.hide) {
    return (
      <PlanNameMobile
        hidePlanName={hidePlanName}
        planname={props.planname ? props.planname : ""}
        plannameClickHandler={(flag, planValue) =>
          props?.onPlanNameChange(flag, planValue, false)
        }
        isPlanNameChecked={isPlanNameChecked}
        resetClickHandler={resetClickHandler}
        selectedFilter={props.selectedFilter}
        setSelectedFilter={props?.setSelectedFilter}
        tempSelectedFilter={tempSelectedFilter.intermrdiateSelection}
      />
    );
  }

  if (showAccessories && props.hide) {
    return (
      <AccessoriesMobile
        hideAccessories={hideAccessories}
        accessoriesMob={props.accessories ? props.accessories : ""}
        accessoriesClickHandler={props?.onAccessoriesChange}
        isAccessoriesChecked={isAccessoriesChecked}
        resetClickHandler={resetClickHandler}
      />
    );
  }

  if (showcontractDuration && props.hide) {
    return (
      <ContractDurationMobile
        hideContractDuraiton={hideContractDuration}
        contarctDuraitonMob={
          props.contractduration ? props.contractduration : ""
        }
        contractdurationClickHandler={(flag, value) =>
          props?.onContractDurationChange(flag, value, false)
        }
        isContractDurationChecked={isContractDurationChecked}
        resetClickHandler={resetClickHandler}
        selectedFilter={props.selectedFilter}
        setSelectedFilter={props.setSelectedFilter}
        tempSelectedFilter={tempSelectedFilter.intermrdiateSelection}
      />
    );
  }

  if (showFilterByProduct && props.hide) {
    return (
      props?.productSearchOnDealGridEnabled && (
        <ProductFilterMobile
          closeRequired={true}
          resetClickHandler={resetClickHandler}
          hideFilter={props.show}
          onSearchTextSelect={props.onProductFilterChange}
          handleError={props.onProductFilterError}
          isEligible={props.isEligible}
          qualifyLabel={labels.lbl_affordability_product_filter}
          selectedFilter={props.selectedFilter}
          brands={props.brands}
        />
      )
    );
  }

  const backToDeals = () => {
    props.show();
    props.toggleFilters(false);
    setIsMounted(false);
    props.setSelectedFilter(tempSelectedFilter.originalSelectection);
  };

  const handleShowResult = () => {
    props.show();
    props.handleApplyFilter();
    props.toggleFilters(false);
    setIsMounted(false);
  };

  return (
    <Fragment>
      {props.hide ? (
        <CustomContainer className={styles["nav-gutter"]}>
          <Fragment>
            {isMobile ? (
              <FilterNav
                headingName="Filter deals"
                backbtn={backToDeals}
                resetClickHandler={resetClickHandler}
                selectedFilter={
                  props.selectedFilter.selectedCategory ||
                  props.selectedFilter.subCategories ||
                  props.selectedFilter.promotions ||
                  props.selectedFilter.brands ||
                  props.selectedFilter.price ||
                  props.selectedFilter.promo_data ||
                  props.selectedFilter.minutes ||
                  props.selectedFilter.airtime ||
                  props.selectedFilter.contracttype ||
                  props.selectedFilter.plantypes ||
                  props.selectedFilter.planname ||
                  props.selectedFilter.accessories ||
                  props.selectedFilter.contractduration
                }
              />
            ) : (
              <FilterNav
                headingName="Filter deals"
                backbtn={backToDeals}
                resetClickHandler={resetClickHandler}
                selectedFilter={
                  props.selectedFilter.selectedCategory ||
                  props.selectedFilter.subCategories ||
                  props.selectedFilter.promotions ||
                  props.selectedFilter.brands ||
                  props.selectedFilter.price ||
                  props.selectedFilter.promo_data ||
                  props.selectedFilter.minutes ||
                  props.selectedFilter.airtime ||
                  props.selectedFilter.contracttype ||
                  props.selectedFilter.plantypes ||
                  props.selectedFilter.planname ||
                  props.selectedFilter.accessories ||
                  props.selectedFilter.contractduration
                }
              />
            )}
            <Products
              selectedFilter={props.selectedFilter}
              categoriesList={props.categoriesList}
              category={toggleCategory}
              selectedProductID={props?.selectedCategory?.id}
              hide={props.hide}
              selectedProductName={props?.selectedCategory?.name}
              subCategory={toggleSubCategory}
              handleCategorySelect={(category) =>
                handleCategorySelect(category)
              }
              allProductsClickHandler={allProductsClickHandler}
              handleSubCategorySelect={(subCategory) =>
                selectSubCategoryChange(true, subCategory)
              }
              isDealGridPage={props.isDealGridPage}
            />
            {props.brands?.length > 0 && (
              <Brands
                brands={props.brands}
                branditem={toggleBrand}
                filteredBrands={props.selectedFilter.brands}
                handleBrandSelect={props?.onBrandChange}
                displaySelectedBrands={true}
              />
            )}
            <DealSliderFilter
              selectedFilter={props?.selectedFilter}
              displaySlider={
                Number(priceMaxValue) !=
                  props.priceRange[props.priceRange?.length - 1] ||
                Number(priceMinValue) != Number(props.priceRange[0])
              }
              price={togglePrice}
              valueRange={props.priceRange}
              missingValueRange={props?.missingPriceRange}
              min={
                props?.priceValue?.minValue
                  ? Number(props.priceValue.minValue)
                  : Number(props.priceRange[0]) || 0
              }
              max={
                props?.priceValue?.maxValue
                  ? Number(props.priceValue?.maxValue)
                  : Number(props?.maxPrice)
              }
              minValue={0}
              maxValue={Number(props?.maxPrice)}
              selectPrice={selectPrice}
              isDealGridPage={props.isDealGridPage}
              heading="Price"
              type="price"
            />
            {props.promotions?.length > 0 && (
              <Promotions
                promotions={props.promotions}
                filteredPromotions={props.selectedFilter.promotions}
                promo={togglePromotions}
                displaySelectedPromotion={true}
                handlePromotionSelect={props?.onPromotionChange}
              />
            )}
            {props.contracttype?.length > 0 && (
              <ContractType
                contracttypes={props.contracttype}
                filteredContractType={props.selectedFilter.contracttype}
                toggleContractTypes={toggleContractTypes}
                onContractTypeChange={selectContractType}
                contractsList={props?.contractsList}
                selectedFilter={props?.selectedFilter}
                displayContractType={true}
              />
            )}
            {props.plantype?.length > 0 && (
              <PlanType
                planType={props.plantype}
                filteredPlanType={props.selectedFilter.plantypes}
                plan={togglePlanTypes}
                handlePlanTypeSelect={props?.onPlanTypeChange}
                displayPlanType={true}
              />
            )}
            <DealSliderFilter
              selectedFilter={props.selectedFilter}
              displaySlider={
                (props.promoValue &&
                  Number(props?.promoValue[1]?.label) != FIXED.MAX_DATA) ||
                (props.promoValue &&
                  Number(props?.promoValue[0]?.label) != 0) ||
                (props.vmValue &&
                  Number(props?.vmValue[1]?.label) != FIXED.MAX_MINUTES) ||
                (props.vmValue && Number(props?.vmValue[0]?.label) != 0) ||
                (props.airValue &&
                  Number(props?.airValue[1]?.label) != FIXED.MAX_AIRTIME) ||
                (props.airValue && Number(props?.airValue[0]?.label) != 0)
                  ? true
                  : false
              }
              dispalyDataValue={
                (props.promoValue &&
                  Number(props?.promoValue[1]?.label) != FIXED.MAX_DATA) ||
                (props.promoValue && Number(props?.promoValue[0]?.label) != 0)
                  ? true
                  : false
              }
              dispalyVmValue={
                (props.vmValue &&
                  Number(props?.vmValue[1]?.label) != FIXED.MAX_MINUTES) ||
                (props.vmValue && Number(props?.vmValue[0]?.label) != 0)
                  ? true
                  : false
              }
              dispalyAirtimeValue={
                (props.airValue &&
                  Number(props?.airValue[1]?.label) != FIXED.MAX_AIRTIME) ||
                (props.airValue && Number(props?.airValue[0]?.label) != 0)
                  ? true
                  : false
              }
              price={toggleDataVmAirtime}
              min={
                props?.promoValue?.[0]?.label
                  ? Number(props?.promoValue[0]?.label)
                  : 0
              }
              max={
                props?.promoValue?.[1]?.label
                  ? Number(props?.promoValue[1]?.label)
                  : FIXED.MAX_DATA
              }
              minValue={FIXED.MIN_DATA}
              maxValue={FIXED.MAX_DATA}
              minVm={
                props?.vmValue?.[0]?.label
                  ? Number(props?.vmValue[0]?.label)
                  : 0
              }
              maxVm={
                props?.vmValue?.[1]?.label
                  ? Number(props?.vmValue[1]?.label)
                  : FIXED.MAX_MINUTES
              }
              minValueVm={FIXED.MIN_MINUTES}
              maxValueVm={FIXED.MAX_MINUTES}
              minAir={props && props?.airValue ? props?.airValue[0]?.label : 0}
              maxAir={
                props && props?.airValue
                  ? props?.airValue[1]?.label
                  : FIXED.MAX_AIRTIME
              }
              minValueAir={FIXED.MIN_AIRTIME}
              maxValueAir={FIXED.MAX_AIRTIME}
              isDealGridPage={props.isDealGridPage}
              heading="Monthly data / voice minutes / airtime"
              type="datavmairtime"
              selectData={selectDataMobile}
            />
            {props.contractduration?.length > 0 && (
              <ContractDuration
                contractdurationList={props.contractduration}
                displayContractDuration={true}
                filteredContractDuration={props.selectedFilter.contractduration}
                ContractDuration={toggleContractDuration}
                handleAccessoriesSelect={props?.onContractDurationChange}
              />
            )}
            {props.planname?.length && (
              <PlanName
                displayPlanName={true}
                planName={props.planname}
                filteredPlanName={props.selectedFilter.plannames}
                planNames={togglePlanNames}
                handlePlannameSelect={props?.onPlanNameChange}
              />
            )}
            {props?.accessories?.length > 0 && (
              <Accessories
                accessoriesList={props.accessories}
                displayAccessories={true}
                filteredAccessories={props.selectedFilter.accessories}
                Accessories={toggleAccessories}
                handleAccessoriesSelect={props?.onAccessoriesChange}
              />
            )}
          </Fragment>
          <CustomContainer className={`${styles["show-results"]} pr-2`}>
            <button
              className={styles["show-results__button"]}
              onClick={handleShowResult}
            >
              Apply filters
            </button>
          </CustomContainer>
        </CustomContainer>
      ) : (
        <Fragment>
          <CustomContainer className={`${styles.hide} d-none d-lg-block`}>
            <Fragment>
              {props.productSearchOnDealGridEnabled && (
                <ProductFilter
                  closeRequired={true}
                  onSearchTextSelect={props.onProductFilterChange}
                  handleError={props.onProductFilterError}
                  isEligible={props.isEligible}
                  qualifyLabel={labels.lbl_affordability_product_filter}
                  brands={props.brands}
                />
              )}
              <Products
                categoriesList={props.categoriesList}
                selectedFilter={props.selectedFilter}
                handleCategorySelect={(category) =>
                  handleCategorySelect(category)
                }
                allProductsClickHandler={allProductsClickHandler}
                handleSubCategorySelect={(subCategory) =>
                  selectSubCategoryChange(true, subCategory)
                }
                isDealGridPage={props.isDealGridPage}
              />
              <DealSliderFilter
                price={togglePrice}
                min={
                  props?.priceValue?.minValue
                    ? Number(props.priceValue.minValue)
                    : 0
                }
                max={
                  props?.priceValue?.maxValue
                    ? Number(props.priceValue?.maxValue)
                    : Number(props?.maxPrice)
                }
                minValue={0}
                maxValue={Number(props?.maxPrice)}
                selectPrice={selectPrice}
                isDealGridPage={props.isDealGridPage}
                heading="Price"
                type="price"
                valueRange={props.priceRange}
                missingValueRange={props?.missingPriceRange}
                selectedTypeValue={selectedType}
                resetClickHandler={resetClickHandler}
                showQualifyDeals={props.showQualifyDeals}
                qualifyLabel="You can upgrade to a deal that falls within the above price range"
              />
              {props.brands?.length > 0 && (
                <Brands
                  brands={props.brands}
                  filteredBrands={props.selectedFilter.brands}
                  handleBrandSelect={props?.onBrandChange}
                />
              )}
              {props.promotions?.length > 0 && (
                <Promotions
                  promotions={props.promotions}
                  filteredPromotions={props.selectedFilter.promotions}
                  promo={togglePromotions}
                  handlePromotionSelect={props?.onPromotionChange}
                />
              )}
              {!isMobile ? (
                <ContractType
                  contracttypes={props.contracttype}
                  filteredContractType={props.selectedFilter.contracttype}
                  toggleContractTypes={toggleContractTypes}
                  onContractTypeChange={selectContractType}
                  contractsList={props.contractsList}
                  selectedFilter={props.selectedFilter}
                />
              ) : (
                ""
              )}
              <PlanType
                planType={props.plantype}
                filteredPlanType={props.selectedFilter.plantypes}
                plan={togglePlanTypes}
                handlePlanTypeSelect={props?.onPlanTypeChange}
              />
              <DealSliderFilter
                price={toggleData}
                min={
                  props?.promoValue?.[0]?.label
                    ? Number(props?.promoValue[0]?.label)
                    : 0
                }
                max={
                  props?.promoValue?.[1]?.label
                    ? Number(props?.promoValue[1]?.label)
                    : FIXED.MAX_DATA
                }
                minValue={FIXED.MIN_DATA}
                maxValue={FIXED.MAX_DATA}
                selectData={selectData}
                isDealGridPage={props.isDealGridPage}
                heading="Data"
                type="data"
                selectedTypeValue={selectedType}
                resetClickHandler={resetClickHandler}
              />
              <DealSliderFilter
                price={toggleVoiceMinutes}
                min={
                  props?.vmValue?.[0]?.label
                    ? Number(props?.vmValue[0]?.label)
                    : 0
                }
                max={
                  props?.vmValue?.[1]?.label
                    ? Number(props?.vmValue[1]?.label)
                    : FIXED.MAX_MINUTES
                }
                minValue={FIXED.MIN_MINUTES}
                maxValue={FIXED.MAX_MINUTES}
                selectVoiceMinutes={selectVoiceMinutes}
                isDealGridPage={props.isDealGridPage}
                heading="Voice minutes"
                type="vm"
                selectedTypeValue={selectedType}
                resetClickHandler={resetClickHandler}
              />
              <DealSliderFilter
                selectedFilter={props.selectedFilter}
                price={toggleAirtime}
                min={props && props?.airValue ? props?.airValue[0]?.label : 0}
                max={
                  props && props?.airValue
                    ? props?.airValue[1]?.label
                    : FIXED.MAX_AIRTIME
                }
                minValue={FIXED.MIN_AIRTIME}
                maxValue={FIXED.MAX_AIRTIME}
                selectAirTime={selectAirTime}
                isDealGridPage={props.isDealGridPage}
                heading="Airtime"
                type="airtime"
                selectedTypeValue={selectedType}
                resetClickHandler={resetClickHandler}
              />
              <ContractDuration
                contractdurationList={props.contractduration}
                filteredContractDuration={props.selectedFilter.contractduration}
                ContractDuration={toggleContractDuration}
                handleContratcDurationSelect={props?.onContractDurationChange}
              />
              <PlanName
                planName={props.planname}
                filteredPlanName={props.selectedFilter.plannames}
                planNames={togglePlanNames}
                handlePlannameSelect={props?.onPlanNameChange}
              />
              {props.accessories?.length > 0 && (
                <Accessories
                  accessoriesList={props.accessories}
                  filteredAccessories={props.selectedFilter.accessories}
                  Accessories={toggleAccessories}
                  handleAccessoriesSelect={props?.onAccessoriesChange}
                />
              )}
            </Fragment>
          </CustomContainer>
        </Fragment>
      )}
    </Fragment>
  );
};

DealGridSearchContainer.propTypes = {
  hide: PropTypes.any,
  show: PropTypes.any,
  categoriesList: PropTypes.object,
  displayHideFooter: PropTypes.func,
  moreFilter: PropTypes.array,
  selectedFilter: PropTypes.object,
  isDealGridPage: PropTypes.bool,
  priceValue: PropTypes.object,
  selectedContractType: PropTypes.array,
  selectedCategory: PropTypes.object,
  brands: PropTypes.array,
  promotions: PropTypes.array,
  maxPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onPriceTypeChange: PropTypes.func,
  onPriceChange: PropTypes.func,
  onFilterReset: PropTypes.func,
  onFilterChanged: PropTypes.func,
  onBrandChange: PropTypes.func,
  onPromotionChange: PropTypes.func,
  onContractTypeChange: PropTypes.func,
  onPlanTypeChange: PropTypes.func,
  onPlanNameChange: PropTypes.func,
  onAccessoriesChange: PropTypes.func,
  onContractDurationChange: PropTypes.func,
  onDataChange: PropTypes.func,
  onCategoryChange: PropTypes.func,
  onSubCategoryChange: PropTypes.func,
  priceRange: PropTypes.array,
  onProductFilterChange: PropTypes.func,
  onProductFilterError: PropTypes.func,
  isEligible: PropTypes.bool,
  showProductFilter: PropTypes.bool,
  productSearchOnDealGridEnabled: PropTypes.bool,
};

export default connect(null, {
  displayHideFooter,
  toggleFilters,
})(DealGridSearchContainer);
